/* Bayou Beignet: sticky header shrink. The scroll-to-open hero owns its
   lifecycle separately in bb-hero-unpack.js. */
(function () {
  var ticking = false;

  function update() {
    document.body.classList.toggle('bb-shrunk', (window.scrollY || 0) > 200);
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
})();

/* Powdered sugar that falls off the beignet buttons on hover, focus,
   and click. Particles are tiny spans removed when their fall finishes;
   the whole thing is skipped when the visitor prefers reduced motion. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var SELECTOR = '.bb-btn, .product-form__submit';

  function fleck(btn) {
    var span = document.createElement('span');
    span.className = 'bb-sugar-fleck';
    var size = 2.5 + Math.random() * 3.5;
    span.style.left = (8 + Math.random() * 84) + '%';
    span.style.top = (32 + Math.random() * 46) + '%';
    span.style.width = size.toFixed(1) + 'px';
    span.style.height = size.toFixed(1) + 'px';
    span.style.setProperty('--drift', (Math.random() * 26 - 13).toFixed(1) + 'px');
    span.style.setProperty('--fall', (30 + Math.random() * 30).toFixed(1) + 'px');
    span.style.animationDuration = (0.65 + Math.random() * 0.5).toFixed(2) + 's';
    span.addEventListener('animationend', function () { span.remove(); });
    btn.appendChild(span);
  }

  function burst(btn, count) {
    for (var i = 0; i < count; i++) fleck(btn);
  }

  function attach(btn) {
    if (btn.dataset.bbSugar) return;
    btn.dataset.bbSugar = '1';
    var timer = null;

    btn.addEventListener('mouseenter', function () {
      if (reduce.matches || timer) return;
      burst(btn, 3);
      timer = setInterval(function () { burst(btn, 2); }, 220);
    });
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    btn.addEventListener('mouseleave', stop);
    btn.addEventListener('blur', stop);
    btn.addEventListener('focus', function () {
      if (!reduce.matches) burst(btn, 4);
    });
    btn.addEventListener('click', function () {
      if (!reduce.matches) burst(btn, 16);
    });
  }

  function init() {
    var btns = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < btns.length; i++) attach(btns[i]);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
